import { Loader2 } from "lucide-react";

/**
 * Step 4 — cert issuance. Pure spinner; parent's poll loop transitions
 * automatically when wizard_state advances to `assigning`.
 */
export function IssuingStep() {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-xs">
        <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
        <span>Issuing TLS certificate…</span>
      </div>
      <div className="text-2xs text-subtle-foreground">
        Caddy requests a Let's Encrypt cert on first HTTPS hit. Usually takes 5–30 seconds.
      </div>
    </div>
  );
}
